module.exports = {"defaultId":"UA-123178620-1","products":"UA-123178620-2","ourlearnings":"UA-123178620-3","whoweare":"UA-123178620-4","selflearning":"UA-123178620-5","personalisedlearning":"UA-123178620-6","landing":"UA-123178620-7","homework":"UA-123178620-9"}


//////////////////
// WEBPACK FOOTER
// ./src/config/GA_Tracking_IDS.json
// module id = 1198
// module chunks = 0